import apiClient from '@shared/api'
import type IUser from '@shared/api/user-management/resources/user/user'

export const getUser = ({ userId }: { userId: string }): Promise<IUser> => {
  return apiClient.get(`/users/${userId}`)
}

export const updateUser = ({ userId, data }: { userId: string; data: IUser }): Promise<IUser> => {
  return apiClient.put(`/users/${userId}`, data)
}
